<template>
  <div>
    <el-card class="add-product-info-header"
             shadow="nerver">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>基本信息</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="add-product-info-content"
             shadow="nerver">
      <!-- 所在目的地 -->
      <div class="content-line-dest"
           style="display: flex">
        <label class="content-dest">
          <span class="required"
                style="color: red">*</span>
          所在目的地：
        </label>

        <div>
          <el-cascader style="width: 250px"
                       size="mini"
                       :show-all-levels="false"
                       v-model="selectDests"
                       :options="option"
                       :props="defaultProp"
                       clearable
                       filterable></el-cascader>
        </div>
      </div>
      <!-- 商品标题 -->
      <div class="content-line"
           style="display: flex">
        <div class="content-title">
          <span class="required"
                style="color: red">*</span>
          产品名称：
        </div>
        <div class="content-input">
          <el-input size="mini"
                    v-model="spu_name"
                    placeholder="请输入产品标题"
                    maxlength="20"
                    show-word-limit></el-input>
        </div>
      </div>

      <!-- 商品编码 -->
      <div class="content-line"
           style="display: flex">
        <div class="content-title">
          <span class="required"
                style="color: red">*</span>
          产品编码：
        </div>
        <div class="content-input">
          <el-input size="mini"
                    v-model="out_spu_id"
                    placeholder="请输入产品编码"
                    maxlength="15"
                    show-word-limit></el-input>
        </div>
        <el-link style="margin-left: 10px"
                 @click="creatOutSpuId"
                 :underline="false"
                 type="primary"
                 icon="el-icon-refresh">生成编号</el-link>
      </div>
      <!-- 产品主图 -->
      <div class="content-img"
           style="display: flex">
        <div class="content-title">
          <span class="required"
                style="color: red">*</span>
          产品主图：
        </div>
        <div class="content-upload">
          <el-upload class="avatar-uploader"
                     :name="file_name"
                     :action="$ip + '/add_image?key_name=spu_image'"
                     :show-file-list="false"
                     :with-credentials="true"
                     :on-success="handleAvatarSuccess"
                     :before-upload="beforeAvatarUpload"
                     accept=".jpg, .jpeg, .png, .gif">
            <img v-if="imageUrl"
                 :src="imageUrl"
                 class="avatar" />
            <i v-else
               class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import Editor from '../../components/common/editor/editorV1'

export default {
  name: 'spu-setting',
  components: {
    'editor-info': Editor,
  },
  data() {
    return {
      file_name: 'image',
      imageUrl: '', // 绑定后端图片的文件名称
      image_url: '', // 主图链接
      spu_name: '', // 产品名称
      out_spu_id: '', // 商家编码
      selectDests: [], // 绑定对应选项的value值
      spu_introduce: '', // 富文本产品说明
      defaultProp: {
        multiple: true,
        checkStrictly: true,
        label: 'loc_name', // 指定选项标签为选项对象的某个属性值
        value: 'loc_id', // 指定选项的值为选项对象的某个属性值
        children: 'children', // 指定选项的子选项为选项对象的某个属性值
      },
      option: [],
    }
  },
  created() {
    this.loadDest()
  },

  methods: {
    // 生成spu out id
    creatOutSpuId() {
      let post_info = {
        dest: this.selectDests,
        sku_name: this.spu_name,
      }
      this.$http.post('/creat_spu_out_id', post_info).then((res) => {
        const { out_spu_id, errno, errmsg } = res.data
        if (errno == '4002') {
          this.$notify({
            title: '警告',
            message: errmsg,
            type: 'warning',
          })
        } else if (errno == '0') {
          this.out_spu_id = out_spu_id
        }
      })
    },
    // 获取 目的地信息
    loadDest() {
      this.$http.get('/get_dest_level').then((res) => {
        this.option = res.data.data
      })
    },

    // 上传文件前 的 钩子 函数
    beforeAvatarUpload(file) {
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isFORMAT) {
        this.$message.error('上传头像图片只能是 JPG/png/gif 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      // console.log(file);
      return isFORMAT && isLt2M
    },
    // 上传成功时的钩子函数，将返回值添加到页面中
    handleAvatarSuccess(res, file) {
      // console.log(res.data.image_url);
      this.image_url = res.data.image_url
      // 让图片可以展示在前端
      this.imageUrl = URL.createObjectURL(file.raw)
    },
  },
}
</script>

<style>
.content-server {
  margin: 0 10px;
}
.content-title {
  text-align: center;
  padding: 5px 0;
  margin-right: 10px;
}

.content-input {
  width: 300px;
}

.content-line-dest {
  margin-bottom: 20px;
}

.content-dest {
  padding: 10px 0;
}

/* 主图 */
.avatar-uploader .el-upload {
  margin-top: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.add-product-info-header {
  border-radius: 3px 3px 0px 0px;
}

.add-product-info-content {
  border-radius: 0px 0px 0px 0px;
}

.add-product-info-footer {
  border-radius: 0px 0px 3px 3px;
}
</style>